var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-number-devices"},[_c('div',{staticClass:"content-badge"},[_c('span',{staticClass:"badge badge-primary"},[_vm._v(_vm._s(_vm.totalCount))]),_vm._v(" "),_c('span',{staticClass:"hidden-mobile-small"},[_vm._v("\n      "+_vm._s(_vm.$t('common.blocks.trips', {count: _vm.totalCount}))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }